export default __webpack_public_path__ + "static/media/include_6@3x.20b72a9e.jpg";